<template>
<div id="">
  <v-container fluid class="pt-0 ">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">
          <v-card-title class="secondary white--text">
            Creator Liability
            <v-spacer></v-spacer>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-container class=" white--text">
            <v-row align="center">

              <v-col cols="12" md="12" lg="3" xl="2">
                <v-text-field v-model="search" append-icon="fa-search" dark label="Search" outlined hide-details clearable></v-text-field>
              </v-col>
              <v-spacer></v-spacer>

              <v-col cols="12" md="12" lg="9" xl="7" class="text-right">
                <v-chip outlined label dark large class="mr-2">Total Outstanding {{totalOutstanding | decimal}}</v-chip>
                <v-chip outlined label dark large>Total Unclaimed {{totalUnclaimed | decimal}}</v-chip>
                <v-chip outlined label dark large class="ml-2">Total Liability {{totalLiability | decimal}}</v-chip>
              </v-col>


            </v-row>
            <v-data-table :loading="loading" :headers="headers" :items="accountsList" :search="search">

              <template v-slot:item.name="{ item }">
                <router-link  :to="`/admin/users/${item.id}`">{{item.name}}</router-link>
                </template>


              <template v-slot:item.total_project_payments_earned="{ item }">
                  {{item.total_project_payments_earned | decimal}}
            </template>
              <template v-slot:item.total_support_payments_earned="{ item }">
                {{item.total_support_payments_earned | decimal}}
          </template>
              <template v-slot:item.total_earned_to_date="{ item }">
              {{item.total_earned_to_date | decimal}}
        </template>
              <template v-slot:item.total_payments_requested="{ item }">
            {{item.total_payments_requested | decimal}}
      </template>
              <template v-slot:item.total_paid="{ item }">
          {{item.total_paid | decimal}}
    </template>
              <template v-slot:item.total_amount_outstanding="{ item }">
        {{item.total_amount_outstanding | decimal}}
  </template>
              <template v-slot:item.amount_earned_not_invoiced="{ item }">
      {{item.amount_earned_not_invoiced | decimal}}
</template>

<template v-slot:item.total_liability="{ item }">
{{item.total_liability | decimal}}
</template>

<template v-slot:item.notification="{ item }">
<v-btn icon small color="primary" @click="$eventBus.$emit('send_notification',{account:item})">
  <v-icon small>fa-paper-plane</v-icon>
</v-btn>
</template>
</v-data-table>
</v-container>
</v-card>
</v-col>
</v-row>
</v-container>

</div>
</template>
<script>
import headersSimple from "./headers_simple.json"


export default {
  name: "",
  data: () => ({
    search: '',
    filter: '',
    filters: ['Pending', 'Paid'],
    loading: false,
    invoices: [],
    accounts: [],
    project_reports: [],
    support_payments: []
  }),
  computed: {
    totalLiability() {
      let total = 0;
      this.accounts.forEach(a => {
        total += a.total_liability
      })
      return total;
    },
    totalOutstanding() {
      let total = 0;
      this.accounts.forEach(a => {
        total += a.total_amount_outstanding
      })
      return total;
    },
    totalUnclaimed() {
      let total = 0;
      this.accounts.forEach(a => {
        total += a.amount_earned_not_invoiced
      })
      return total;
    },
    headers() {
      return headersSimple
    },
    accountsList() {
      return this.accounts
    },
  },
  methods: {
    async load() {
      this.loading = true
      await Promise.all([this.loadWallet()])
      this.loading = false
    },
    async loadWallet() {
      this.accounts = await this.$api(`/account/admin/wallet`)
    }
  },
  created() {
    this.load()
  }
}
</script>
<style lang="scss" scoped>
</style>
